import React from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';

import { NamePartsInput } from 'components/Common/Inputs';
import RadioTableGroup from 'components/Common/Inputs/RadioTableGroup';

function CreateCustomerSection({ customerType, useFullName, setUseFullName, onCustomerTypeChange, nameErrors, disabled }) {
  const entity = customerType === 'entity';

  return (
    <div id="create-customer-section" className="create-customer-section">
      <div className="form-group">
        <div className="col-4 col-sm-12">
          <label htmlFor="customer-name" className="form-label text-right">Customer Name *</label>
        </div>
        <div className="col-3 col-sm-12">
          { entity && <Field
            id="customer-name"
            name="customerName"
            component="input"
            type="text"
            className={ `form-input ${ nameErrors.length > 0 ? 'is-error' : '' }` }
            placeholder="Enter customer name"
            disabled={ disabled }
          /> }
          { !entity && <NamePartsInput
            className="customer-account-name-parts-input"
            disableFields={ disabled }
            useFullNameExternal={ useFullName }
            setUseFullNameExternal={ setUseFullName }
          /> }
        </div>
      </div>
      <div className="form-group">
        <div className="col-4 col-sm-12">
          <label htmlFor="customer-type" className="form-label text-right">Customer Type&nbsp;&nbsp;</label>
        </div>
        <div className="col-8 col-sm-12">
          <RadioTableGroup
            name="customerType"
            items={ [[{ text: 'Individual', value: 'individual' }, { text: 'Entity', value: 'entity' }]] }
            preventReset
            onChange={ (e, newVal, prevVal) => onCustomerTypeChange(e, newVal, prevVal) }
          />
        </div>
      </div>
    </div>
  );
}

CreateCustomerSection.propTypes = {
  customerType: PropTypes.string,
  useFullName: PropTypes.bool,
  setUseFullName: PropTypes.func.isRequired,
  onCustomerTypeChange: PropTypes.func.isRequired,
  nameErrors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool
};

CreateCustomerSection.defaultProps = {
  customerType: null,
  useFullName: true,
  nameErrors: [],
  disabled: false
};

export default CreateCustomerSection;
